const EyeOpenSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
    <path
      fill="var(--eye-open-fill)"
      fillRule="evenodd"
      d="M3.531 12.134C5.365 9.032 8.641 6.5 11.751 6.5c3.11 0 6.385 2.531 8.218 5.633a.237.237 0 0 1 0 .235C18.136 15.468 14.861 18 11.751 18c-3.11 0-6.386-2.532-8.22-5.634a.231.231 0 0 1 0-.231v-.001ZM11.751 5C7.9 5 4.217 8.026 2.24 11.37c-.321.54-.321 1.219 0 1.76 1.976 3.344 5.66 6.37 9.51 6.37 3.85 0 7.533-3.026 9.51-6.368.32-.542.32-1.221 0-1.763C19.283 8.027 15.6 5 11.75 5Zm-1.617 5.634a2.285 2.285 0 1 1 3.235 3.233 2.285 2.285 0 0 1-3.235-3.233Zm4.243-1.01a3.714 3.714 0 1 1-5.253 5.253 3.714 3.714 0 1 1 5.253-5.253Z"
      clipRule="evenodd"
    />
  </svg>
)
export { EyeOpenSvg }
